import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cx-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  message: any;
  constructor() { }

  ngOnInit(): void {
  }

}
